module.exports = __webpack_public_path__ + "static/kobe-7-ec6b4791f29f56e69f91d5cf10b57050.jpg";